import axios, { AxiosRequestConfig } from 'axios';

export interface UploadUrlResponse {
  method: AxiosRequestConfig['method'];
  assetUrl: string;
  url: string;
  expires: string;
}

export default async function getUploadUrl(extension: string) {
  const res = await axios.post<UploadUrlResponse>(
    '/api/v2/profiles/media-upload', {
    file_extension: extension,
  });
  return res.data;
}